<template>
    <div class="container-fluid m-0 p-0 bg bg-pj-jc animated fadeIn slow">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div class="container px-0" style="position: relative;">
            <div class="d-flex flex-column" style="height: 99vh;">
                <TheHeader/>
                <!--user account info : {{userRole}}-->
                <div class="align-self-center my-auto">
                    <div>
                        <div class="title font-italic font-weight-bold text-uppercase font-xxl">
                            Login
                        </div>
                        <div class="lime-bar-diag">
                            <img src="../assets/img/Asset_3.png" alt="">
                        </div>
                    </div>
                    <div class="mt-2 pt-5"><span class="text-uppercase font-weight-bold font-italic label">email: </span>
                        <input v-model="email" type="email"
                               style="transform: translateY(-5px);">
                    </div>
                    <div class=" mt-3">
                    <span class="text-uppercase font-weight-bold font-italic label"
                          style="margin-left: -45px;">Password: </span>
                        <input v-model="password" type="password"
                               style="transform: translateY(-5px);"
                               @keyup.enter="login()">
                    </div>
                    <!--<div class="lime-bar-diag">
                        <img src="../assets/img/Asset_3.png" alt="" class="ml-5 pl-5">
                    </div>-->
                    <div id="request"
                         class="text-uppercase font-weight-light font-sm font-italic">
                        <router-link to="/register">request login</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import logo from '@/components/RufusLogo'
    import firebase from 'firebase'
    import TheHeader from '../components/TheHeader'

    export default {
        name      : 'Login',
        components: {
            logo,
            TheHeader
        },
        data () {
            return {
                email   : null,
                password: null
            }
        },
        computed: {
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        methods   : {
            login () {
                let self = this
                let userDetails      = {}
                userDetails.email    = self.email
                userDetails.password = self.password
                if (userDetails.email && userDetails.password) {
                    this.$store.dispatch('login', userDetails)
                }

            }
        },
        watch: {
            userRole (val) {
                if ( val === 'admin' || val === 'driver' || val === 'industry' ) {
                    // console.log('admin or driver...');
                    this.$router.push({path: '/toc'})
                }
            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>

<style scoped>
    input {
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid #999999;
        position: relative;
        z-index: 1;
        background: transparent;
    }

    #request {
        color: #666666;
        letter-spacing: 3px;
        transform: translateY(120px);
        padding-left: 300px;
    }

    .label {
        color: #999999;
    }

    .bg-pj-jc {
        background-image: url(../assets/img/PJ-JC.png);
    }

    a {
        color: #666666;
        text-decoration: none;
    }

    @media all and (max-width: 576px) {

        #request {
            transform: translateY(0px);
            padding-left: 150px;
        }

        .lime-bar-diag img {
            width: 150px;
            height: auto;
            transform: translateY(10px);
            margin-left: 0;
            padding-left: 0;
        }
    }

    @media all and (min-width: 1200px) {

    }
</style>
